// extracted by mini-css-extract-plugin
module.exports = {"categories":"styles-module--categories--3i4eX"};